import brandTheme from '../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const styles = {
  uploadFile: {
    color: colors.primary,
    textAlign: 'end',
    '& > span': {
      cursor: 'pointer',
    },
  },
}
